import type { FC, PropsWithChildren } from 'react';

import { cn } from '@shared/utils';

/**
 * 1. flex-1 + min-h-0: CRITICAL. This establishes the "Flex Jail".
 * It forces this container to stop growing at the viewport edge,
 * allowing children (like Data Grids) to scroll internally.
 * WARNING: Changing this to h-full or removing min-h-0 will break all the grids and make them invisible.
 */

interface PageTemplateProps extends PropsWithChildren {
  className?: string;
  contentClassName?: string;
}

const PageTemplate: FC<PageTemplateProps> = ({ children, className = '', contentClassName = '' }) => {
  return (
    <div
      className={cn('flex flex-col flex-1 min-h-0 w-full overflow-x-hidden', className)}
      data-testid="page-template-container"
    >
      <div
        className={cn(
          'flex flex-col flex-1 min-h-0 w-full min-w-full md:min-w-3xl max-w-400 mx-auto px-16 pt-6 pb-12',
          contentClassName,
        )}
        data-testid="page-template-content"
      >
        {children}
      </div>
    </div>
  );
};

export { PageTemplate };
